import { Link } from "@mui/material";

const TelLink = ({ children, tel, ...rest }) => {

  let cleanedTel = tel?.trim();

  if (cleanedTel) {
    const hasPlus = cleanedTel.startsWith("+");
    cleanedTel = cleanedTel.replace(/\D/g, "");
    if (hasPlus) cleanedTel = `+${cleanedTel}`;
  }

  return (
    <Link href={`tel:${cleanedTel}`} underline="none" {...rest}>
      {children || tel}
    </Link>
  );
};

export default TelLink;
